import React, { useState, useEffect, useCallback, useRef } from 'react'
import {
  Modal,
  Button,
  ListGroup,
  Form,
  Spinner,
  Tabs,
  Tab
} from 'react-bootstrap'
import Select from 'react-select'
import { supabase } from '../../supabaseClient'
import ConfirmationPopup from './ConfirmationPopup'
import EditPopup from './EditPopup'
import AddTaskPopUp from './AddTaskPopup'
import PortalDropdown from './PortalDropdown'
import TaskAssistantChat from './TaskAssistantChat'
import ChatAssistantInput from './ChatAssistantInput'
import MultiSelectFilterBar from './MultiSelectFilterBar'
import QuickSharePopup from './QuickSharePopup'
import ShareSectionPopup from './ShareSectionPopup'
import { TbFilterCog } from 'react-icons/tb'
import '../../assets/css/checklist.css'

import moment from 'moment-timezone'

import { DateFormtter } from '../../utils'
const NotesExpandAllPopup = ({
  isDarkMode,
  show,
  handleClose,
  title,
  category,
  subcategory,
  search,
  keyTab,
  childKeyTab,
  UserId,
  isNotesCategoryUpdate,
  isNotesDataChannelUpdate
}) => {
  const [categories, setCategories] = useState([])
  const [subcategories, setSubcategories] = useState([])
  const [selectedCategory, setSelectedCategory] = useState('')
  const [selectedSubcategory, setSelectedSubcategory] = useState('')
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(false)
  const [completedTasks, setCompletedTasks] = useState({})
  const [tasks, setTasks] = useState([])
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [taskToRemove, setTaskToRemove] = useState(null)
  const [showEditPopup, setShowEditPopup] = useState(false)
  const [taskToEdit, setTaskToEdit] = useState(null)
    const [showAddPopup, setShowAddPopup] = useState(false)
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [isChatMinimized, setIsChatMinimized] = useState(false);
    const [chatInput, setChatInput] = useState('');
    const [chatWidthPercent, setChatWidthPercent] = useState(70);
    const [isResizing, setIsResizing] = useState(false);
    const chatAssistantRef = useRef(null);
    const modalBodyRef = useRef(null);

  // Resize handler for chat width
  const handleResizeStart = useCallback((e) => {
    e.preventDefault();
    setIsResizing(true);
  }, []);

  const handleResizeMove = useCallback((e) => {
    if (!isResizing || !modalBodyRef.current) return;

    const modalBody = modalBodyRef.current;
    const modalRect = modalBody.getBoundingClientRect();
    const mouseX = e.clientX - modalRect.left;
    const modalWidth = modalRect.width;

    const chatWidth = modalWidth - mouseX;
    let newPercent = (chatWidth / modalWidth) * 100;

    newPercent = Math.max(20, Math.min(70, newPercent));
    setChatWidthPercent(newPercent);
  }, [isResizing]);

  const handleResizeEnd = useCallback(() => {
    setIsResizing(false);
  }, []);

  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', handleResizeMove);
      document.addEventListener('mouseup', handleResizeEnd);
      document.body.style.cursor = 'col-resize';
      document.body.style.userSelect = 'none';
    } else {
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeEnd);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    }
    return () => {
      document.removeEventListener('mousemove', handleResizeMove);
      document.removeEventListener('mouseup', handleResizeEnd);
      document.body.style.cursor = '';
      document.body.style.userSelect = '';
    };
  }, [isResizing, handleResizeMove, handleResizeEnd]);

  const [taskChannel, setTaskChannel] = useState(null)
  const [groupedTasks, setGroupedTasks] = useState({
    today: [],
    next7Days: [],
    next30Days: [],
    later: [],
    last7Days: [],
    last30Days: [],
    previous: []
  })
  const [categoryUpdateCode, setCategoryUpdateCode] = useState(null)
 const [checkedSessions, setCheckedSessions] = useState([])
  const [deleteAllChecked, setDeleteAllChecked] = useState(false)
  // New for delete UX
  const [showDeleteDropdown, setShowDeleteDropdown] = useState(false);
  const [deleteFilter, setDeleteFilter] = useState('all'); // 'pending', 'completed', 'all'
  const [statusFilters, setStatusFilters] = useState(new Set(["pending"])); // default: hide completed
  const [showModalFilters, setShowModalFilters] = useState(false);
  const [quickShareState, setQuickShareState] = useState(null)
  const [showSharePopup, setShowSharePopup] = useState(false)
  const [sharedNotes, setSharedNotes] = useState([])
  const [sharedCategories, setSharedCategories] = useState([])
  const [sentNoteIds, setSentNoteIds] = useState(new Set())
  const [sentCategoryIds, setSentCategoryIds] = useState(new Set())
  useEffect(() => {
    setSelectedCategory(category) // Set initial selected category
    setSelectedSubcategory(subcategory) // Set initial selected subcategory
    setSearchTerm(search) // Set initial search term
  }, [category, subcategory, search, keyTab, childKeyTab])

  
  console.log("isDarkMode,", isDarkMode)
  useEffect(() => {
    if (selectedCategory) {
      fetchSubcategories(selectedCategory)
    }
  }, [selectedCategory])
  // useEffect(() => {
  //   if (key === 'tasks') {
  //     fetchTasksTab(searchTerm, selectedCategory, selectedSubcategory)
  //   } else {
  //     if (childKey === 'upcoming') {
  //       fetchDueTasks(searchTerm, selectedCategory, selectedSubcategory)
  //     } else {
  //       fetchOverDueTask(searchTerm, selectedCategory, selectedSubcategory)
  //     }
  //   }
  // }, [selectedCategory, selectedSubcategory, searchTerm, keyTab])
 useEffect(() => {
    fetchCategories();
    fetchSharedNotes();
    fetchSentNoteIds();
    if(categoryUpdateCode!==null){
      fetchSubcategories(categoryUpdateCode);
    }
  } , [isNotesCategoryUpdate])
  useEffect(() => {

    fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
    setDeleteAllChecked(false)
    setCheckedSessions([])
  } , [isNotesDataChannelUpdate])
  useEffect(() => {
    fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
    setDeleteAllChecked(false)
    setCheckedSessions([])
  }, [selectedCategory, selectedSubcategory, searchTerm])
  
  // Fetch data when popup opens
  useEffect(() => {
    if (show && UserId) {
      fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
      fetchCategories()
    }
  }, [show, UserId])
  const fetchTasks = useCallback(
    async (search = '', categoryId = '', subcategoryId = '') => {
      if (UserId) {
        try {
          let query = supabase
            .from('notes')
            .select('id, title, description, status, category_id', {
              count: 'exact'
            })
            .eq('user_id', UserId)
            .or('is_share.is.null,is_share.eq.false')
            .ilike('title', `%${search}%`)
            // .order('status', { ascending: false })
            .order('created_at', { ascending: false }) // Newly created tasks first

            // .gt('due_date', moment().startOf('day').toISOString())
          if (subcategoryId) {
            query = query.eq('category_id', subcategoryId)
          } else if (categoryId) {
            const { data: subcategories } = await supabase
              .from('notes_categories')
              .select('id')
              .eq('parent_category_id', categoryId)
            const subcategoryIds = subcategories.map(sub => sub.id)
            query = query.in('category_id', [categoryId, ...subcategoryIds])
          }

          const { data, error, count } = await query
          if (error) {
            throw error
          }

          const sorted = data.sort((a, b) => {
            // Step 1: Prioritize 'pending' before 'completed'
            if (a.status !== b.status) {
              return a.status === 'pending' ? -1 : 1;
            }
          
            // Step 2: If both are 'pending', sort by created_at (newest first)
            if (a.status === 'pending') {
              return new Date(b.created_at) - new Date(a.created_at);
            }
          
            // Step 3: If both are 'completed', keep original order or sort alphabetically
            return 0; // ← No further sorting for completed
          });
          setTasks(sorted)
                    const completed = {}
          data.forEach(task => {
            completed[task.id] = task.status === 'completed'
          })
          setCompletedTasks(completed)

        } catch (error) {
          console.error('Error fetching tasks:', error)
        }
      }
    },
    [UserId]
  )

  const fetchCategories = async () => {
    try {
      if (UserId) {
        const { data, error } = await supabase
          .from('notes_categories')
          .select('id, name, is_share')
          .eq('user_id', UserId)
          .is('parent_category_id', null)
          .or('is_share.is.null,is_share.eq.false')
        if (error) {
          console.log('erro notesr', error)

          throw error
        }
        setCategories(data)
      }
    } catch (error) {
      console.error('Error fetching categories:', error)
    }
  }
  const fetchSubcategories = async categoryId => {
    try {
      const { data, error } = await supabase
        .from('notes_categories')
        .select('id, name, is_share')
        .eq('user_id', UserId)
        .eq('parent_category_id', categoryId)
        .or('is_share.is.null,is_share.eq.false')
      if (error) {
        throw error
      }
      setSubcategories(data)
    } catch (error) {
      console.error('Error fetching subcategories:', error)
    }
  }
  const fetchSharedNotes = useCallback(async () => {
    if (!UserId) return
    try {
      const { data: shared } = await supabase
        .from('notes')
        .select('id, title, description, status, category_id, shared_by, share_visible')
        .eq('user_id', UserId)
        .eq('is_share', true)
        .not('shared_by', 'is', null)
        .order('created_at', { ascending: false })

      const items = (shared || []).map(t => ({
        ...t, _shared: true, _sharedFrom: t.shared_by || 'Unknown', _isNew: t.share_visible === false
      }))
      setSharedNotes(items)

      const catIds = [...new Set(items.map(t => t.category_id).filter(id => id && id !== 0))]
      if (catIds.length > 0) {
        const { data: cats } = await supabase
          .from('notes_categories')
          .select('id, name, parent_category_id')
          .in('id', catIds)
        const parentIds = (cats || []).map(c => c.parent_category_id).filter(id => id && !catIds.includes(id))
        let parentCats = []
        if (parentIds.length > 0) {
          const { data } = await supabase.from('notes_categories').select('id, name').in('id', [...new Set(parentIds)])
          parentCats = data || []
        }
        const allCatMap = {}
        ;[...(cats || []), ...parentCats].forEach(c => { allCatMap[c.id] = c })
        const parents = []
        const seen = new Set()
        ;(cats || []).forEach(cat => {
          const pid = cat.parent_category_id || cat.id
          if (!seen.has(String(pid))) {
            seen.add(String(pid))
            const name = cat.parent_category_id ? (allCatMap[cat.parent_category_id]?.name || cat.name) : cat.name
            parents.push({ id: `shared_${pid}`, originalId: String(pid), name: `${name} (shared)` })
          }
        })
        setSharedCategories(parents)
      } else {
        setSharedCategories([])
      }
    } catch (e) { console.error('Error fetching shared notes:', e) }
  }, [UserId])

  const fetchSentNoteIds = useCallback(async () => {
    if (!UserId) return
    try {
      const API_URL = process.env.REACT_APP_ZOOMEY_API_URL || 'http://localhost:3000'
      const res = await fetch(`${API_URL}/api/sharing/sent-task-ids?user_id=${UserId}&section_type=notes`)
      const data = await res.json()
      setSentNoteIds(new Set((data?.sent_task_ids || []).map(String)))
      setSentCategoryIds(new Set((data?.sent_category_ids || []).map(String)))
    } catch (e) { console.error('Error fetching sent note ids:', e) }
  }, [UserId])

  useEffect(() => { if (UserId) { fetchSharedNotes(); fetchSentNoteIds(); } }, [UserId, fetchSharedNotes, fetchSentNoteIds])

  const syncSharedNote = async (noteId, updates) => {
    try {
      const API_URL = process.env.REACT_APP_ZOOMEY_API_URL || 'http://localhost:3000'
      await fetch(`${API_URL}/api/sharing/sync-task`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ task_id: noteId, user_id: UserId, updates, section_type: 'notes' }),
      })
    } catch (e) { console.error('Error syncing shared note:', e) }
  }

  const handleCategoryChange = e => {
    const categoryId = e.target.value
    setCategoryUpdateCode(categoryId)
    setSelectedCategory(categoryId)
    setSelectedSubcategory('')
    fetchSubcategories(categoryId)
    fetchTasks(searchTerm, categoryId)
  }

  const handleSubcategoryChange = e => {
    const subcategoryId = e.target.value
    setSelectedSubcategory(subcategoryId)
    fetchTasks(searchTerm, selectedCategory, subcategoryId)
  }

const handleTaskCreated = () => {

  fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
};
  const handleSearchChange = e => {
    setSearchTerm(e.target.value)
    fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
  }

  const handleSearch = () => {
    let filtered = tasks.filter(
      task =>
        task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        task.description.toLowerCase().includes(searchTerm.toLowerCase())
    )

    if (selectedSubcategory) {
      filtered = filtered.filter(
        task => task.category_id === parseInt(selectedSubcategory, 10)
      ) // Ensure subcategoryId is an integer
    } else if (selectedCategory) {
      filtered = filtered.filter(
        task => task.category_id === parseInt(selectedCategory, 10)
      ) // Ensure categoryId is an integer
    }

    setTasks(filtered)
  }
  
  const toggleTaskCompletion = async (taskId, isShared = false) => {
    if (isShared) {
      const item = sharedNotes.find(t => t.id === taskId)
      const newStatus = item?.status === 'completed' ? 'pending' : 'completed'
      try {
        const { error } = await supabase.from('notes').update({ status: newStatus }).eq('id', taskId)
        if (error) throw error
        setSharedNotes(prev => prev.map(t => t.id === taskId ? { ...t, status: newStatus } : t))
        syncSharedNote(taskId, { status: newStatus })
      } catch (error) { console.error('Error updating shared note status:', error) }
    } else {
      const newStatus = completedTasks[taskId] ? 'pending' : 'completed'
      try {
        const { error } = await supabase
          .from('notes')
          .update({ status: newStatus })
          .eq('id', taskId)
        if (error) {
          throw error
        }
        setCompletedTasks(prev => ({
          ...prev,
          [taskId]: !prev[taskId]
        }))
        setTasks(
          tasks.map(task =>
            task.id === taskId ? { ...task, status: newStatus } : task
          )
        )
        syncSharedNote(taskId, { status: newStatus })
      } catch (error) {
        console.error('Error updating task status:', error)
      }
    }
  }
  const confirmRemoveTask = taskId => {
    setTaskToRemove(taskId)
    setShowConfirmation(true)
  }
  const removeTask = async () => {
    setLoading(true)
    // Check if we're in multiselect mode (showDeleteDropdown) and have selected items
    if (showDeleteDropdown && checkedSessions.length > 0) {
      // Filter out any null/undefined IDs before deletion
      const validIds = checkedSessions.filter(id => id != null)
      if (validIds.length === 0) {
        console.error('No valid IDs to delete')
        setShowConfirmation(false)
        setLoading(false)
        return
      }

      try {
        // Use batch delete with .in() for better performance and error handling
        const { error } = await supabase
          .from('notes')
          .delete()
          .in('id', validIds)

        if (error) {
          throw error
        }

        setTasks(prev => prev.filter(task => !validIds.includes(task.id)))
        fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
      } catch (error) {
        console.error('Error removing notes:', error)
      } finally {
        setLoading(false)
        setDeleteAllChecked(false)
        setCheckedSessions([])
        setShowConfirmation(false)
        setTaskToRemove(null)
        setShowDeleteDropdown(false)
      }
    } else {
      // Single item deletion
      if (!taskToRemove) {
        console.error('No note ID to delete')
        setShowConfirmation(false)
        setLoading(false)
        return
      }

      try {
        const { error } = await supabase
          .from('notes')
          .delete()
          .eq('id', taskToRemove)
        if (error) {
          throw error
        }
        setTasks(prev => prev.filter(task => task.id !== taskToRemove))
        fetchTasks(searchTerm, selectedCategory, selectedSubcategory)
      } catch (error) {
        console.error('Error removing note:', error)
      } finally {
        setShowConfirmation(false)
        setTaskToRemove(null)
        setLoading(false)
      }
    }
  }

  const handleEditTask = task => {
    setTaskToEdit(task)
    setShowEditPopup(true)
  }

  //   useEffect(() => {
  //     fetchCategories()
  //     if (categoryUpdateCode !== null) {
  //       fetchSubcategories(categoryUpdateCode)
  //     }
  //   }, [isCategoryUpdateListTaskPopup])

  //   useEffect(() => {
  //     if (key === 'tasks') {
  //       fetchTasksTab(searchTerm, selectedCategory, selectedSubcategory)
  //     } else {
  //       if (childKey === 'upcoming') {
  //         fetchDueTasks(searchTerm, selectedCategory, selectedSubcategory)
  //       } else {
  //         fetchOverDueTask(searchTerm, selectedCategory, selectedSubcategory)
  //       }
  //     }
  //   }, [isTaskChannelUpdateListTaskPopup, key, childKey])

  useEffect(() => {
    fetchCategories()
    fetchTasks()
    setDeleteAllChecked(false)
    setCheckedSessions([])
  }, [UserId, searchTerm, selectedCategory, selectedSubcategory])
  //  call the above effect for real time also

  const saveTask = async updatedTask => {
    try {
      let categoryId = updatedTask.category_id

      // Handle new category creation
      if (updatedTask.isNewCategory && updatedTask.category_id) {
        const { data: catData, error: catError } = await supabase
          .from('notes_categories')
          .insert([{
            name: updatedTask.category_id,
            parent_category_id: null,
            user_id: UserId
          }])
          .select()

        if (catError) {
          console.error('Error creating category:', catError)
          throw catError
        }
        categoryId = catData[0].id

        // Handle new subcategory creation (requires new category to be created first)
        if (updatedTask.isNewSubcategory && updatedTask.subcategory_id) {
          const { data: subData, error: subError } = await supabase
            .from('notes_categories')
            .insert([{
              name: updatedTask.subcategory_id,
              parent_category_id: categoryId,
              user_id: UserId
            }])
            .select()

          if (subError) {
            console.error('Error creating subcategory:', subError)
            throw subError
          }
          categoryId = subData[0].id
        }
      } else if (updatedTask.isNewSubcategory && updatedTask.subcategory_id) {
        // Creating new subcategory under existing category
        const parentCategoryId = updatedTask.category_id
        const { data: subData, error: subError } = await supabase
          .from('notes_categories')
          .insert([{
            name: updatedTask.subcategory_id,
            parent_category_id: parentCategoryId,
            user_id: UserId
          }])
          .select()

        if (subError) {
          console.error('Error creating subcategory:', subError)
          throw subError
        }
        categoryId = subData[0].id
      } else if (updatedTask.subcategory_id && /^\d+$/.test(updatedTask.subcategory_id)) {
        // Using existing subcategory
        categoryId = updatedTask.subcategory_id
      }

      const updateData = {
        title: updatedTask.title,
        description: updatedTask.description
      }

      // Don't change category for shared/sent notes
      if (!updatedTask._shared && !updatedTask._sent) {
        if (categoryId && categoryId !== "0") {
          updateData.category_id = categoryId
        }
      }

      const { error } = await supabase
        .from('notes')
        .update(updateData)
        .eq('id', updatedTask.id)
        .eq('user_id', UserId)
      if (error) {
        throw error
      }

      syncSharedNote(updatedTask.id, {
        title: updateData.title,
        description: updateData.description,
      })

      // Refresh categories if new ones were created
      if (updatedTask.isNewCategory || updatedTask.isNewSubcategory) {
        fetchCategories()
        if (selectedCategory) {
          fetchSubcategories(selectedCategory)
        }
      }

      if (updatedTask._shared) {
        setSharedNotes(prev =>
          prev.map(task => (task.id === updatedTask.id ? { ...task, ...updateData } : task))
        )
      } else {
        setTasks(prev =>
          prev.map(task => (task.id === updatedTask.id ? { ...updatedTask, category_id: categoryId } : task))
        )
      }
      setShowEditPopup(false)
      setTaskToEdit(null)
    } catch (error) {
      console.error('Error updating note:', error)
    }
  }
  const formatMessage = text => {
    if (!text) return '';
    let cleanedText = text
      .replace(/\\"/g, '"') // Handle escaped quotes (\" becomes ")
      .replace(/^"/, '') // Remove leading quotation mark (if any)
      .replace(/"$/, '') // Remove trailing quotation mark (if any)
      .replace(/\\n/g, '') // Remove all escaped newlines (if any)
      .replace(/\n+/g, '</p><p>') // Convert multiple newlines to paragraph breaks
      .replace(/\{(.*?)\}/g, '$1'); // Remove curly braces
    
    return cleanedText
      .replace(/###\s*(.*?)(?:\n|$)/g, '<h5>$1</h5>') // H3 headings (###)
      .replace(/##\s*(.*?)(?:\n|$)/g, '<h4>$1</h4>') // H2 headings (##)
      .replace(/#\s*(.*?)(?:\n|$)/g, '<h3>$1</h3>') // H1 headings (#)
      .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') // Bold text (**bold**)
      .replace(/(\d+)\.\s+(.*?)(?:\n|$)/g, (match, num, item) => {
        return `<ol start="${num}"><li>${item}</li></ol>`; // Numbered lists (1. item)
      })
      .replace(
        /`(.*?)`/g,
        '<code style="background-color: #f0f0f0; padding: 2px 4px; border-radius: 4px; font-family: monospace;">$1</code>' // Inline code (`code`)
      )
      .replace(
        /\[(.*?)\]\((https?:\/\/[^\s]+)\)/g,
        '<a href="$2" target="_blank">$1</a>' // Links [text](URL)
      )
      .replace(/^\n|\n$/g, '') // Remove leading/trailing newlines after paragraph breaks
      .replace('<p></p>', ''); // Remove empty paragraphs (if any)
  };
  
    const renderTask = (
       taskId,
       title,
       description,
       due_date,
       category_id,
       flag,
       expandedDescriptions,
       setExpandedDescriptions,
       isShared = false,
       sharedFrom = '',
       isNew = false,
       isSent = false
     ) => {
       const toggleDescription = (id) => {
         console.log('clicked', expandedDescriptions)
         setExpandedDescriptions((prev) => ({
           ...prev,
           [id]: true,
         }));
       };
     
       // Helper to strip HTML tags for word counting
       const stripHtml = (html) => {
         if (!html) return '';
         const div = document.createElement('div');
         div.innerHTML = html;
         return div.textContent || div.innerText || '';
       };

       const truncateHtml = (html, wordLimit) => {
         if (!html) return '';
         const div = document.createElement('div');
         div.innerHTML = html;
         const text = div.textContent || div.innerText || '';
         const words = text.split(' ').filter(w => w.trim());
         if (words.length <= wordLimit) return html;

         // Truncate HTML content while preserving tags
         let wordCount = 0;
         const truncate = (node) => {
           if (wordCount >= wordLimit) return '';
           if (node.nodeType === Node.TEXT_NODE) {
             const nodeWords = node.textContent.split(' ').filter(w => w.trim());
             const remaining = wordLimit - wordCount;
             if (nodeWords.length <= remaining) {
               wordCount += nodeWords.length;
               return node.textContent;
             } else {
               wordCount = wordLimit;
               return nodeWords.slice(0, remaining).join(' ') + '...';
             }
           } else if (node.nodeType === Node.ELEMENT_NODE) {
             const tag = node.tagName.toLowerCase();
             const attrs = Array.from(node.attributes).map(a => `${a.name}="${a.value}"`).join(' ');
             const openTag = attrs ? `<${tag} ${attrs}>` : `<${tag}>`;
             const closeTag = `</${tag}>`;
             let inner = '';
             for (const child of node.childNodes) {
               inner += truncate(child);
               if (wordCount >= wordLimit) break;
             }
             return `${openTag}${inner}${closeTag}`;
           }
           return '';
         };

         let result = '';
         for (const child of div.childNodes) {
           result += truncate(child);
           if (wordCount >= wordLimit) break;
         }
         return result;
       };

       const truncateDescription = (desc, isExpanded) => {
         if (!desc) return { text: '', isHtml: true };
         const plainText = stripHtml(desc);
         const words = plainText.split(' ').filter(w => w.trim());
         if (words.length > 100 && !isExpanded) {
           // Return truncated HTML when over 100 words and not expanded
           return { text: truncateHtml(desc, 100), isHtml: true };
         }
         // Return original HTML content
         return { text: desc, isHtml: true };
       };
     
       const isExpanded = expandedDescriptions[taskId];
       const formattedDescription = description && truncateDescription(description, isExpanded);
     
       return (
         <div className="d-flex align-items-start mb-3 sidelist" key={taskId}>
           {flag ? (
             <>
               <Form.Check
                 type="checkbox"
                 style={{
                   marginTop: '10px',
                   marginRight: '15px',
                   cursor: 'pointer',
                 }}
                 checked={checkedSessions.includes(taskId)}
                 onChange={() => handleCheckboxChange(taskId)}
               />
             </>
           ) : (
             <i
               className={`bi ${
                 completedTasks[taskId] ? 'bi-check2-square' : 'bi bi-square'
               }`}
               style={{
                 fontSize: '1.2em',
                 marginTop: '10px',
                 marginRight: '15px',
                 cursor: 'pointer',
               }}
               onClick={() => toggleTaskCompletion(taskId, isShared)}
             ></i>
           )}
     
           <div
             style={{
               flex: 1,
             }}
              onClick={() =>
                   handleEditTask({ id: taskId, title, description, category_id, _shared: isShared, _sent: isSent })
                 }
           >
             <div className="d-flex align-items-center gap-1">
             <p
               style={{
                 fontSize: '16px',
                 margin: '0',
                 fontWeight: 'bolder',
                 overflow: 'hidden',
                 textOverflow: 'ellipsis',
                 display: '-webkit-box',
                 WebkitBoxOrient: 'vertical',
                 cursor: 'pointer',
                 textDecoration: completedTasks[taskId] ? 'line-through' : 'none',
               }}
               title={title}
             >
               {title}
             </p>
               {isNew && (
                 <span style={{
                   fontSize: '0.55rem', fontWeight: 700, textTransform: 'uppercase',
                   background: 'var(--teal-bg)', color: '#fff',
                   padding: '1px 5px', borderRadius: '3px', flexShrink: 0, lineHeight: '13px',
                 }}>New</span>
               )}
             </div>
             <div
               style={{
                 fontSize: '14px',
                 overflow: 'hidden',
                 marginBottom: '0',
                 textOverflow: 'ellipsis',
                 display: '-webkit-box',
                 WebkitBoxOrient: 'vertical',
                 cursor: 'pointer',
                 textDecoration: completedTasks[taskId] ? 'line-through' : 'none',
               }}
               title={stripHtml(description)}
             >
               <span dangerouslySetInnerHTML={{ __html: formattedDescription?.text || '' }} />{' '}
               {description && stripHtml(description).split(' ').filter(w => w.trim()).length > 100 && (
                 <span
                   style={{ color: 'blue', cursor: 'pointer' }}
                   onClick={(e) => { e.stopPropagation(); toggleDescription(taskId); }}
                 >
                   {isExpanded ? null : 'More'}
                 </span>
               )}
             </div>
             { (isShared ? sharedNotes.find(t => t.id === taskId)?.status === 'completed' : completedTasks[taskId]) ?
          <span className='message-success-label fw-normal' style={{padding:"2px 10px" }}>Completed</span>
          :
          <span className='message-success-label fw-normal' style={{ backgroundColor: 'var(--orange-bg)', padding:"2px 10px"}}>Pending</span>
        }
          {isShared && (
            <div
              title={`Received from ${sharedFrom} — Click to copy email`}
              onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(sharedFrom); }}
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '3px',
                fontSize: '0.65rem', color: 'var(--teal-bg)', marginTop: '4px',
                cursor: 'pointer', padding: '1px 6px', borderRadius: '4px',
                background: 'rgba(var(--teal-bg-rag), 0.08)',
              }}
            >
              <i className="bi bi-box-arrow-in-down-right" style={{ fontSize: '0.7rem' }}></i>
            </div>
          )}
          {isSent && !isShared && (
            <div
              title="Shared to others"
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '3px',
                fontSize: '0.65rem', color: '#f59e0b', marginTop: '4px',
                padding: '1px 6px', borderRadius: '4px',
                background: 'rgba(245, 158, 11, 0.08)',
              }}
            >
              <i className="bi bi-box-arrow-up-right" style={{ fontSize: '0.7rem' }}></i>
            </div>
          )}
           </div>
           {!isShared && (
             <i
               className="bi bi-send"
               style={{ fontSize: '0.85rem', cursor: 'pointer', color: '#14b8a6', padding: '2px 4px' }}
               title="Quick Share"
               onClick={(e) => { e.stopPropagation(); setQuickShareState(quickShareState?.id === taskId ? null : { id: taskId, rect: e.currentTarget.getBoundingClientRect() }) }}
             ></i>
           )}
           {quickShareState?.id === taskId && (
             <QuickSharePopup
               show={true}
               onClose={() => setQuickShareState(null)}
               itemId={taskId}
               sectionType="notes"
               UserId={UserId}
               isDarkMode={isDarkMode}
               onShareSuccess={fetchSentNoteIds}
               anchorRect={quickShareState?.rect}
             />
           )}
           {!flag && (
             <PortalDropdown
               align="end"
               menuItems={[
                 {
                   label: 'Edit',
                   icon: 'bi bi-pencil',
                   onClick: () => handleEditTask({ id: taskId, title, description, category_id, _shared: isShared, _sent: isSent })
                 },
                 {
                   label: 'Remove',
                   icon: 'bi bi-trash',
                   danger: true,
                   onClick: () => confirmRemoveTask(taskId),
                   disabled: isShared || isSent,
                   title: isShared ? 'No authority' : isSent ? 'Unshare to use' : '',
                 }
               ]}
             >
               <i
                 className="bi bi-three-dots-vertical"
                 style={{ fontSize: '1em', cursor: 'pointer', color: 'var(--text)' }}
               ></i>
             </PortalDropdown>
           )}
         </div>
       );
     };
  // Merge own + shared notes
  const filteredShared = sharedNotes.filter(st => {
    if (tasks.some(t => t.id === st.id)) return false
    if (!selectedCategory) return true
    if (selectedCategory === '0') return !st.category_id
    if (String(selectedCategory).startsWith('shared_')) {
      const origId = selectedCategory.replace('shared_', '')
      return String(st.category_id) === origId
    }
    return false
  })
  const mergedTasks = [
    ...tasks.map(t => ({ ...t, _sent: sentNoteIds.has(String(t.id)) })),
    ...filteredShared
  ]

  const statusCounts = {
    pending: mergedTasks.filter(t => t.status === 'pending').length,
    completed: mergedTasks.filter(t => t.status === 'completed').length,
  };

  const filteredTasks = mergedTasks.length
    ? mergedTasks.filter(task => {
        const matchesSearch = task.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (task.description && task.description.toLowerCase().includes(searchTerm.toLowerCase()));
        const matchesStatus = statusFilters.size === 0 || statusFilters.has(task.status);
        return matchesSearch && matchesStatus;
      })
    : []
  const handleCheckboxChange = sessionId => {
    console.log('clicked child', checkedSessions)

    setCheckedSessions(prev =>
      prev.includes(sessionId)
        ? prev.filter(id => id !== sessionId)
        : [...prev, sessionId]
    )
  }
  const handleDeleteAll = () => {
    setDeleteAllChecked(!deleteAllChecked)
    if (deleteAllChecked == false) {
      let allSession = []

      filteredTasks.map(session => {
        if (session.id) allSession.push(session.id)
      })
      setCheckedSessions(allSession)
    } else {
      setCheckedSessions([])
    }
  }
  const handleDeleteCheckedItems = () =>{
    console.log('clicked child', checkedSessions.length) 
    setShowConfirmation(true)
          
  }
  
  // Filter for delete dropdown
  const deleteFilteredTasks = (() => {
    let allCurrentTasks = tasks; // Notes only have one source
    
    // Apply filter
    if (deleteFilter === 'pending') return allCurrentTasks.filter(task => task.status === 'pending');
    if (deleteFilter === 'completed') return allCurrentTasks.filter(task => task.status === 'completed');
    return allCurrentTasks; // 'all'
  })();
  
  // Handle deleteAllChecked for dropdown filtered list
  const handleDeleteDropdownAll = () => {
    setDeleteAllChecked(!deleteAllChecked)
    if (deleteAllChecked == false) {
      let allSession = []
      deleteFilteredTasks.map(session => {
        if (session.id) allSession.push(session.id)
      })
      setCheckedSessions(allSession)
    } else {
      setCheckedSessions([])
    }
  };
  
  // When dropdown filter changes, check all relevant tasks
  useEffect(() => {
    if (showDeleteDropdown) {
      // When filter changes, auto-select all filtered tasks
      setDeleteAllChecked(true);
      const filteredTaskIds = deleteFilteredTasks.filter(task => task.id != null).map(task => task.id);
      setCheckedSessions(filteredTaskIds);
    }
  }, [deleteFilter, showDeleteDropdown]);
  return (
    <Modal show={show} onHide={handleClose} size='xl' className='task-popup export-popup' centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
        <button
          style={{ marginLeft: 'auto', marginRight: '8px', background: '#14b8a6', color: '#fff', border: 'none', borderRadius: '6px', padding: '4px 14px', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
          title="Share"
          onClick={(e) => { e.stopPropagation(); setShowSharePopup(true) }}
        ><i className="bi bi-share" style={{ fontSize: '0.8rem' }}></i> Share</button>
      </Modal.Header>
      <ShareSectionPopup
        isDarkMode={isDarkMode}
        show={showSharePopup}
        handleClose={() => setShowSharePopup(false)}
        UserId={UserId}
        sectionType="notes"
      />
      <Modal.Body ref={modalBodyRef} className='export-more' style={{ overflow: 'visible', display: 'flex', flexDirection: 'row', height: '70vh', padding: 0 }}>
        {/* Resize Handle */}
        {!isChatMinimized && (
          <div
            onMouseDown={handleResizeStart}
            style={{
              width: '14px',
              height: '100%',
              background: 'var(--border-color, #d5e5e3)',
              cursor: 'col-resize',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              order: 1,
              position: 'relative',
              zIndex: 10,
              transition: 'background 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = 'var(--teal-bg, #b8d4d0)'}
            onMouseLeave={(e) => e.currentTarget.style.background = 'var(--border-color, #d5e5e3)'}
          >
            <i className="bi bi-grip-vertical" style={{ fontSize: '1rem', color: 'var(--text, #666)', opacity: 0.6 }}></i>
          </div>
        )}

        {/* Notes Assistant Chat - RIGHT SIDE */}
        <div style={{
          width: isChatMinimized ? '0px' : `${chatWidthPercent}%`,
          minWidth: isChatMinimized ? '0px' : '280px',
          maxWidth: isChatMinimized ? '0px' : '70%',
          height: '100%',
          transition: isResizing ? 'none' : 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
          borderLeft: isChatMinimized ? 'none' : 'none',
          display: 'flex',
          flexDirection: 'column',
          flexShrink: 0,
          position: 'relative',
          background: isChatMinimized ? 'transparent' : '#FBF9FA',
          overflow: 'visible',
          order: 2
        }}>
          <TaskAssistantChat
            ref={chatAssistantRef}
            isDarkMode={isDarkMode}
            onToggle={(minimized) => setIsChatMinimized(minimized)}
            showInput={false}
            externalInput={chatInput}
            onExternalInputChange={setChatInput}
            contextType="note"
            contextId={selectedCategory || null}
            categoryPath={(() => {
              const path = [];
              if (selectedCategory) {
                const cat = categories.find(c => c.id === parseInt(selectedCategory, 10));
                if (cat) path.push(cat.name);
              }
              if (selectedSubcategory) {
                const subcat = subcategories.find(s => s.id === parseInt(selectedSubcategory, 10));
                if (subcat) path.push(subcat.name);
              }
              return path;
            })()}
            userId={UserId}
            onItemsUpdated={() => {
              fetchTasks(searchTerm, selectedCategory, selectedSubcategory);
            }}
          />
        </div>

        {/* Notes List Section - LEFT SIDE */}
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          padding: '16px',
          order: 0
        }}>
        <div className="checklist-tabs-header" style={{ padding: 0, marginBottom: '12px' }}>
          <span style={{ fontWeight: '600', fontSize: '14px' }}>Notes</span>
          <div className='d-flex align-items-center gap-2'>
            <button
              className={`filter-toggle-btn ${showModalFilters ? 'active' : ''}`}
              onClick={() => setShowModalFilters(!showModalFilters)}
              title={showModalFilters ? 'Hide filters' : 'Show filters'}
            >
              <TbFilterCog size={20} />
            </button>
            {!showDeleteDropdown && (
              <>
                <button
                  className='btn btn-danger'
                  style={{
                    backgroundColor: "var(--teal-bg)",
                    color: "var(--textwhite)",
                    borderRadius: '5px',
                    borderColor: "var(--teal-bg)",
                  }}
                  onClick={() => {
                    setShowAddPopup(true)
                  }}
                >
                  <i className='bi bi-plus'></i>
                </button>
                <button
                  className='btn btn-danger'
                  style={{
                    borderRadius: '5px',
                  }}
                  onClick={() => {
                    setSearchTerm('');
                    setDeleteFilter('all');
                    setShowDeleteDropdown(true);
                    setDeleteAllChecked(true);
                    const allTaskIds = tasks.filter(task => task.id != null).map(task => task.id);
                    setCheckedSessions(allTaskIds);
                  }}
                >
                  <i className='bi bi-trash'></i>
                </button>
              </>
            )}
          </div>
        </div>
        {showModalFilters && (
          <>
            <div className='d-flex mb-3 gap-2'>
              <Select
                className='popup-select-container flex-fill'
                classNamePrefix='popup-select'
                options={[
                  { value: '', label: 'All Categories' },
                  { value: '0', label: 'General' },
                  ...categories.map(category => ({
                    value: category.id,
                    label: category.name,
                    isReceived: category.is_share === true,
                    isSent: sentCategoryIds.has(String(category.id)),
                  })),
                  ...sharedCategories.map(sc => ({
                    value: sc.id,
                    label: sc.name.replace(' (shared)', ''),
                    isShared: true,
                  }))
                ]}
                formatOptionLabel={(option) => (
                  <div className="d-flex align-items-center gap-1">
                    {option.isReceived && <i className="bi bi-box-arrow-in-down-right" style={{ fontSize: '0.7rem', color: 'var(--teal-bg)' }}></i>}
                    {option.isSent && <i className="bi bi-box-arrow-up-right" style={{ fontSize: '0.7rem', color: '#f59e0b' }}></i>}
                    {option.isShared && <i className="bi bi-box-arrow-in-down-right" style={{ fontSize: '0.7rem', color: 'var(--teal-bg)' }}></i>}
                    <span>{option.label}</span>
                  </div>
                )}
                value={
                  selectedCategory === ''
                    ? { value: '', label: 'All Categories' }
                    : selectedCategory === '0'
                    ? { value: '0', label: 'General' }
                    : categories.find(c => c.id === selectedCategory)
                      ? { value: selectedCategory, label: categories.find(c => c.id === selectedCategory)?.name }
                      : { value: '', label: 'All Categories' }
                }
                onChange={(option) => handleCategoryChange({ target: { value: option?.value || '' } })}
                isSearchable={false}
                placeholder="All Categories"
              />
              <Select
                className='popup-select-container flex-fill'
                classNamePrefix='popup-select'
                options={[
                  { value: '', label: 'All Subcategories' },
                  ...subcategories.map(subcategory => ({
                    value: subcategory.id,
                    label: subcategory.name
                  }))
                ]}
                value={
                  selectedSubcategory === ''
                    ? { value: '', label: 'All Subcategories' }
                    : subcategories.find(s => s.id === selectedSubcategory)
                      ? { value: selectedSubcategory, label: subcategories.find(s => s.id === selectedSubcategory)?.name }
                      : { value: '', label: 'All Subcategories' }
                }
                onChange={(option) => handleSubcategoryChange({ target: { value: option?.value || '' } })}
                isSearchable={false}
                isDisabled={!selectedCategory}
                placeholder="All Subcategories"
              />
            </div>
            {/* Status Filter Bar */}
            {!showDeleteDropdown && (
              <div style={{ marginBottom: "8px" }}>
                <MultiSelectFilterBar
                  isDarkMode={isDarkMode}
                  filterGroups={[
                    {
                      key: "status",
                      label: "Status",
                      options: [
                        { value: "pending", label: "Pending", variant: "success", count: statusCounts.pending },
                        { value: "completed", label: "Completed", variant: "secondary", count: statusCounts.completed },
                      ],
                    },
                  ]}
                  selectedFilters={{ status: statusFilters }}
                  onFilterChange={(groupKey, newSet) => setStatusFilters(newSet)}
                  showDividers={false}
                />
              </div>
            )}
            {!showDeleteDropdown && (
              <div className='d-flex align-items-center mb-3' style={{ gap: '10px' }}>
                <Form.Control
                  type='text'
                  placeholder='Search...'
                  value={searchTerm}
                  onChange={handleSearchChange}
                  style={{ flex: 1 }}
                />
              </div>
            )}
          </>
        )}
        {showDeleteDropdown && (
          <div className='d-flex align-items-center mb-3' style={{ gap: '10px' }}>
            <input
              className='form-check-input'
              type='checkbox'
              style={{
                marginRight: '4px',
                border: '1px solid var(--border-color)',
                width: '18px',
                height: '18px'
              }}
              checked={deleteAllChecked}
              onChange={() => handleDeleteDropdownAll()}
            />
            <Select
              className='popup-select-container'
              classNamePrefix='popup-select'
              options={[
                { value: 'all', label: 'All' },
                { value: 'pending', label: 'Pending' },
                { value: 'completed', label: 'Completed' }
              ]}
              value={
                deleteFilter === 'all'
                  ? { value: 'all', label: 'All' }
                  : deleteFilter === 'pending'
                  ? { value: 'pending', label: 'Pending' }
                  : { value: 'completed', label: 'Completed' }
              }
              onChange={(option) => setDeleteFilter(option?.value || 'all')}
              isSearchable={false}
              styles={{ container: (base) => ({ ...base, flex: 1 }) }}
            />
            <Button
              className='btn-popup-delete'
              disabled={checkedSessions.length === 0}
              onClick={handleDeleteCheckedItems}
            >
              Delete ({checkedSessions.length})
            </Button>
            <Button
              className='btn-popup-cancel'
              onClick={() => {
                setShowDeleteDropdown(false);
                setCheckedSessions([]);
                setDeleteAllChecked(false);
              }}
            >
              Cancel
            </Button>
          </div>
        )}

        {loading ? (
          <div className='text-center'>
            <Spinner animation='border' />
          </div>
        ) : (
          <div
          className="modal-scroll p-3"
          style={{
            flexGrow: 1,
            overflowY: 'scroll',
            overflowX: 'hidden',
          }}
        >
       <ListGroup>
                  <>
                    {(() => {
                      const notesToShow = showDeleteDropdown ? deleteFilteredTasks : filteredTasks;
                      return notesToShow.length > 0 ? (
                        notesToShow.map(task =>
                          renderTask(
                            task.id,
                            task.title,
                            task.description,
                            task.due_date,
                            task.category_id,
                            showDeleteDropdown,
                            expandedDescriptions,
                            setExpandedDescriptions,
                            task._shared || false,
                            task._sharedFrom || '',
                            task._isNew || false,
                            task._sent || false
                          )
                        )
                      ) : (
                        <div className='text-center'>No data found</div>
                      );
                    })()}
                  </>
                </ListGroup>
                </div>
        )}
        </div>
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px 16px' }}>
        <ChatAssistantInput
          chatAssistantRef={chatAssistantRef}
          inputValue={chatInput}
          onInputChange={setChatInput}
          onClearChat={() => chatAssistantRef.current?.clearChat()}
          autoFocus={true}
        />
      </Modal.Footer>
      <ConfirmationPopup
        show={showConfirmation}
        handleClose={() => setShowConfirmation(false)}
        title='Confirm Removal'
        body='Are you sure you want to remove this note? This action cannot be undone.'
        handleConfirm={removeTask}
      />
      <EditPopup
        show={showEditPopup}
        handleClose={() => setShowEditPopup(false)}
        handleSave={saveTask}
        item={taskToEdit}
        categoriesData={categories}
        fetchSubcategories={fetchSubcategories}
        subcategoriesData={subcategories}
        sharedCategories={sharedCategories}
        titleAction='Notes'
        handleDelete={confirmRemoveTask}
      />
       {UserId && (
                          <AddTaskPopUp
                            actionTitle={'Add Note'}
                            show={showAddPopup}
                            handleClose={() => setShowAddPopup(false)}
                            handleSave={saveTask}
                            categoriesData={categories}
                            fetchSubcategories={fetchSubcategories}
                            subcategoriesData={subcategories}
                            UserId={UserId}
                            onTaskCreated={handleTaskCreated}
                          />
                        )}
    </Modal>
  )
}

export default NotesExpandAllPopup
